export const assessments = {
  favorite_assessments: "Evaluaciones favoritas",
  creation: {
    assessment_created: "La evaluación se ha creado con éxito.",
    assessment_is_being_created:
      "Su evaluación se está creando. Por favor, espere un momento mientras completamos el proceso.",
    confirmation_modal: {
      title_with_warnings: "Algunos sitios no heredarán datos",
      title_without_warnings: "Crear Evaluación",
      description_with_warnings:
        "Ha seleccionado una evaluación anterior como punto de partida, pero los sitios no heredarán todos los datos porque le faltan algunos estándares.",
      sites_warning_subtitle: "Los siguientes sitios heredarán datos parciales de la evaluación anterior:",
      continue_confirmation: "¿Desea continuar creando la evaluación de todos modos?",
      create_anyway: "Crear De Todos Modos",
    },
  },
  verification: {
    verification_cannot_be_undone: "Una vez verificado, esta acción no se puede deshacer",
    assessment_verification: "Verificación de la evaluación",
    verifies_this_assessment_on_behalf_of: "verifica esta evaluación en nombre de:",
    verified_this_assessment: "verificó esta evaluación",
    verifies_this_assessment: "verifica esta evaluación",
    date_of_verification: "Fecha en que se realizó la verificación",
    please_enter_verifier: "Por favor, ingrese el verificador",
    send_verification: "Enviar verificación",
    verifier: "Verificador",
  },
  approval: {
    date_of_approval: "Fecha de la aprobación",
  },
  related_questions: "Preguntas relacionadas",
  data_providers_assign: {
    override_warning: "Las asignaciones existentes de proveedores de datos serán reemplazadas.",
    data_provider_overview: "Vista general de los proveedores de datos",
  },
  complete_assessment: {
    action: "Completar evaluación",
    confirm_completion: "Confirmar finalización de evaluación",
    upload_additional_files_to_sites: "Subir archivos adicionales a los sitios",
    upload_file_here: "Por favor, suba un archivo aquí para confirmar la finalización de la evaluación",
    files_assigned_to_whole_assessment: "Archivos asignados a toda la evaluación",
    i_am_aware_that_i_cannot_undo_this_action:
      "Soy consciente de que una vez que decida completar la evaluación, no se puede deshacer. Este proceso es irreversible.",
    assessment_completion_confirmation:
      "La evaluación se ha completado con éxito. Puede encontrarla en la pestaña 'Evaluación completada'.",
  },
  previous_assessment: {
    label: "Evaluación anterior (opcional)",
    description:
      "Puedes seleccionar una evaluación anterior como punto de partida para tu nueva evaluación. Los sitios de la evaluación seleccionada se resaltarán con un ícono en el menú desplegable de abajo, y todos los datos aplicables se copiarán a tu nueva evaluación. <a>Más información</a>",
  },
  starting_point: "Punto de partida de la evaluación",
  reviewers_overview: "Resumen de revisores",
  back_to_overview: "Volver a la vista general",
  site_assessment_progress: "Progreso de la evaluación del sitio",
  Active_assessments: "Evaluaciones activas",
  Completed_assessments: "Evaluaciones completadas",
  add_a_comment: "Añadir un comentario",
  Add_evidence: "Agregar evidencia",
  Add_external_verification: "Agregar verificación externa",
  Add_Step: "Agregar paso",
  approval_cannot_be_undone: "Una vez aprobado, esta acción no se puede deshacer",
  "After_approval,_You_can't_undo_approval": "Después de la aprobación, no puede deshacer la aprobación.",
  All_assessments: "Todas las evaluaciones",
  All_Sites: "Todos los sitios",
  all_sites_description:
    "Cualquier cambio que realice en la selección estándar aquí se aplicará a todos los sitios que seleccionó para esta evaluación.",
  Applicability: "Aplicabilidad",
  Approve: "Aprobar",
  approved_this_assessment: "aprueba esta evaluación",
  Approver: "Aprobador",
  approves_this_assessment: "aprueba esta evaluación",
  approves_this_assessment_on_behalf_of: "aprueba esta evaluación en nombre de:",
  archive_assessment_confirmation:
    "¿Está seguro? Una vez eliminada, esta evaluación y todos los datos relacionados, incluidos los informes, ya no serán accesibles.",
  areas_of_improvement: "Áreas de mejora",
  Assessment_approval: "Assessment approval",
  Assessment_comment_overview: "Resumen de comentarios de evaluación",
  Assessment_list: "Lista de evaluación",
  assessment_name: "Nombre de la evaluación",
  assessment_of_conformity: "Evaluación de la conformidad",
  Assessment_report: "Informe de evaluación",
  Assessment_standard_setup: "Configuración estándar de evaluación",
  Assessment_update: "Actualización de la evaluación",
  assessmentDetails: "Detalles de la evaluación",
  Assessments: "Evaluaciones",
  assign_data_providers: "Asignar Proveedores de Datos",
  Assign_data_providers_to_selected_themes: "Asignar proveedores de datos a temas seleccionados",
  assign_reviewers: {
    "After_confirmation,_this_assigment_will_be_deleted": "Después de la confirmación, esta asignación se eliminará.",
    After_you_confirm_the_section:
      "Después de confirmar la selección, los asignados podrán proporcionar respuestas y evidencias para los protocolos incluidos en los temas seleccionados. No es necesario que asigne todos los temas a la vez.",
    Assign_Reviewers: "Asignar revisores",
    Assign_Reviewers_to_the_Theme: "Asignar revisores al tema",
    Assign_to_selected: "Asignar a seleccionado",
    Assign_Verifiers: "Asignar verificadores",
    Assign_Verifiers_to_an_assessment: "Asignar verificadores a una evaluación",
    Assigned_Themes: "Temas asignados",
    Delete_assigment: "Eliminar tarea",
    Select_Reviewer_for_each_theme: "Seleccione revisor para cada tema",
    Selected_Theme: "Tema seleccionado",
    Step_stepNumber_External_Verification: "Paso {{stepNumber}}: Verificación externa",
    There_are_no_assigned_themes: "No hay temas asignados.",
    There_are_no_unassigned_themes: "No hay temas sin asignar",
    Unassigned_Themes: "Temas no asignados",
    Use_this_window_to_assign_multiply_reviewers_to_selected_themes:
      "Utilice esta ventana para asignar varios revisores a los temas seleccionados",
    Verifiers: "Verificadores",
    View_assessment: "Ver evaluación",
  },
  assign_themes_description:
    "Después de asignar temas, los proveedores de datos serán responsables de completar respuestas de evaluación para sus temas asignados. No es necesario asignar todos los temas para proceder, pero un tema debe estar asignado para que la evaluación de sus requisitos relacionados proceda.",
  assign_themes_header: "Asignar proveedor de datos para cada tema",
  Assigned_Corporate_Coordinator: "Coordinador Corporativo Asignado",
  assigned_themes: "Temas asignados",
  associated_requirements: "Requisitos asociados",
  click_to_select: "Haz clic para seleccionar archivos de tu computadora o arrastra y suelta.",
  Closing_steps: "Pasos finales",
  Comment: "Comentario",
  Comment_and_evidence: "Comentario y evidencia",
  comments: "Comentarios",
  Conformity_assessment: "Evaluación de conformidad",
  conformity_description:
    "La conformidad se refiere al cumplimiento de un requisito y puede requerir evidencia para demostrar tanto el proceso como la implementación, dependiendo de la expectativa declarada.",
  Conformity_level: "Nivel de conformidad",
  Conformity_level_description:
    "El nivel de conformidad mide el cumplimiento con un estándar en términos de rendimiento y calidad. Se utiliza para asegurar criterios específicos de calidad, seguridad o regulación para un producto, servicio o proceso.",
  copy_answer: {
    confirmation: "Copiar estos datos resultará en la sobreescritura de cualquier dato de borrador existente.",
    Filter: "Filtrar",
    site: "Sitio",
    status: "Estado",
  },
  Copy_this: "Copia esto",
  Corporate_coordinator_assigned: "Coordinador corporativo asignado a esta evaluación",
  corporate_guidance: "Orientación corporativa",
  Country: "País",
  Create_assessment: "Crear Evaluación",
  Critical: "Crítico",
  Data_Provider_Assignment: "Asignación de proveedor de datos",
  Data_providers: "Proveedores de datos",
  Data_providers_overview: "Descripción general de los proveedores de datos",
  Default_View: "Vista predeterminada",
  Delete_evidence: "Eliminar evidencia",
  Delete_evidence_confirmation_message: "Después de la confirmación, esta evidencia será eliminada de este protocolo.",
  delete_evidences_description: "Después de la confirmación, esta evidencia será eliminada de este protocolo.",
  Delete_requirement: "Eliminar requisito",
  Description: "Descripción",
  Due_date: "Fecha de vencimiento",
  edit_assessment: "Editar evaluación",
  Edited_by: "Editado por",
  erm_mapping_note: "Nota de mapeo de ERM",
  Evidence_files: "Archivos de evidencia",
  evidences: "evidencias",
  External_Verification: "Verificación externa",
  External_verifiers_can_see_comments: "Los verificadores externos pueden ver los comentarios.",
  External_verifiers_have_been_added_and_they_can_read_comments_made_from_this_point_forward:
    "Se han agregado verificadores externos y pueden leer los comentarios realizados a partir de este momento.",
  File: "Archivo",
  File_upload_error: "Error al cargar el archivo",
  Fill_in_Assessment_Details: "Complete los detalles de la evaluación",
  Filter_by_site: "Filtrar por sitio",
  Filter_by_status: "Filtrar por estado",
  Filters: "Filtros",
  ghost_question_warning:
    "Esta pregunta ya no es válida para esta evaluación debido a la reciente actualización del protocolo. <docsLink>Haga clic aquí</docsLink> para leer nuestra documentación y obtener más información sobre el protocolo y su actualización.",
  Go_back_to_assessments: "Volver a evaluaciones",
  informative: "Informativo",
  internal_audit_awareness:
    "Soy consciente de que el proceso de auditoría o evaluación interna está conectado a los requisitos asociados. *",
  Last_edited: "Última edición",
  make_change_protocol_confirm: "¿Estás seguro de que deseas publicar los cambios?",
  make_change_protocol_confirm_description:
    "Considere dejar un comentario para brindar contexto a otros usuarios con respecto a los cambios que ha realizado.",
  Modify_responses: "Modificar respuestas",
  Needs_review: "Necesita revisión",
  Next_to_review: "Siguiente para revisar",
  No_assessments_match_the_search_criteria: "Ninguna evaluación coincide con los criterios de búsqueda.",
  no_assigned_themes: "No hay temas asignados.",
  No_data_provider_assigned: "No hay ningún proveedor de datos asignado",
  No_more_Protocol_Questions_to_review_at_the_moment: "No hay más preguntas de protocolo para revisar en este momento.",
  no_reviewers_assigned: "No hay revisores asignados.",
  no_reviewer_assignments: "No hay asignaciones de revisores.",
  no_unassigned_themes: "No hay temas sin asignar.",
  normative: "Normativo",
  Notice: "Aviso",
  on_behalf_of: "a nombre de:",

  Please_enter_a_comment: "Por favor introduce un comentario",
  Please_enter_the_approver: "Por favor ingrese el aprobador",
  Please_select_at_least_one_standard:
    "Debe tener al menos un estándar para cada sitio seleccionado. Vuelva atrás y anule la selección de un sitio si no desea evaluarlo.",
  Please_upload_a_file_here_to_confirm_approval_from_your_superior:
    "Cargue un archivo aquí para confirmar la aprobación de su superior",
  Previous: "Previo",
  Publish_changes: "Publicar cambios",
  Question_status: "Estado de la pregunta",
  Reference: "Referencia",
  Reference_data: "Datos de referencia",
  release_drop: "Suelta para dejar los archivos aquí.",
  Report_link: "Enlace de informe",
  reset_default_all_description:
    "Cualquier cambio que realice en la selección estándar aquí se aplicará a todos los sitios que seleccionó para esta evaluación.",
  Review_steps: "Revisar los pasos",
  Reviewed_by: "Revisado por",
  reviewer_assignment_not_available_as_no_assingments_made_yet:
    "La asignación de revisores no está disponible ya que aún no se han realizado asignaciones.",
  Reviewers: "Revisores",
  Role: "Role",
  Search_assessment_by_site_name_or_assessment_name: "Buscar evaluación por nombre del sitio o nombre de la evaluación",
  Search_standard_by_name: "Buscar estándar por nombre",
  Select_data_providers: "Seleccionar proveedores de datos",
  self_assessment_rating: {
    does_not_meat: "No cumple",
    fully_meets: "Cumple completamente",
    not_applicable: "No aplicable",
    partially_meets: "Cumple parcialmente",
    substantially_meets: "Cumple sustancialmente",
  },
  Self_assessment_steps: "Autoevaluación - pasos",
  "Self-assessment": "Autoevaluación",
  Send_Approval: "Enviar aprobación",
  Site: "Sitio",
  Site_coordinator: "Coordinador de sitio",
  Site_coordinators: "Coordinadores de sitio",
  Site_List: "Lista de sitios",
  Site_name: "Nombre del sitio",
  site_setup: "{{siteName}} configuración",
  Sites: "Sitios",
  Staff_and_dates_setup: "Configuración de personal y fechas",
  stakeholders_awareness:
    "Soy consciente de que la participación de los interesados es necesaria para implementar los requisitos asociados. *",
  standard_guidance: "Guía estándar",
  "Standards_not_included_in_this_assessment_will appear_grayed-out_To_view_other_standards":
    "Los estándares no incluidos en esta evaluación aparecerán atenuados. Para ver otros estándares asignados a esta pregunta de protocolo, haga clic en el icono 'Ver'.",
  "Standards_not_included_in_this_assessment_will_appear_grayed-out":
    "Los estándares no incluidos en esta evaluación aparecerán atenuados.",
  status: {
    all_questions: "Todas las preguntas",
    answered: "Contestada",
    assigned_to_me: "Asignado a mí",
    declined: "Rechazado",
    in_draft: "En borrador",
    in_review: "En revisión",
    not_answered: "No Respondido",
    reviewed: "Revisado",
    unassigned: "No asignado",
  },
  Step: "Paso",
  Step_1_Data_Provider_Assignment: "Paso 1: Asignación de proveedor de datos",
  "Step_2_Self-assessment": "Paso 2: Autoevaluación",
  submit_for_review: "Enviar para revisión",
  sumbit_protocol_confirm: "Enviar pregunta del protocolo para revisión",
  sumbit_protocol_confirm_description:
    "Después de la confirmación, esta pregunta del protocolo será enviada para revisión.",
  tasks_comparison: {
    areas_of_improvement: "Áreas de mejora",
    assessment_of_conformity: "Evaluación de conformidad",
    Back_to_the_assessment_list: "Volver a la lista de evaluaciones",
    Comparison_view: "Vista de comparación",
    conformity_level: "Nivel de conformidad",
    evidences: "Evidencias",
    field_name: "Nombre del campo",
  },
  taskstatus: {
    declined: "Esta pregunta del protocolo ha sido rechazada.",
    in_review: "Esta pregunta del protocolo ha sido enviada para la próxima ronda de revisión.",
    reviewed: "Se aprueba la presente Cuestión de Protocolo.",
    not_submitted_for_review: "Esta pregunta del protocolo aún no ha sido enviada para revisión.",
    unassigned: "Esta Pregunta del Protocolo aún no ha sido asignada a nadie.",
  },
  The_standards_you_select_impact_the_themes:
    "Sólo los estándares seleccionados en la configuración del sitio están disponibles para su personalización.",
  Themes_are_not_assigned_yet:
    "Los proveedores de datos aún no han sido asignados. El Coordinador del sitio debe asignar proveedores de datos para cada tema antes de continuar.",
  There_are_currently_no_questions_that_are_available_for_this_Site:
    "Actualmente no hay preguntas disponibles para este sitio.",
  There_are_no_assessments: "No hay evaluaciones.",
  This_is_a_Critical_requirement:
    "Este es un requisito crítico establecido por la Junta de IRMA para obtener cualquier nivel de logro en el sistema IRMA.",
  This_is_data_provide_view: "Estos son datos que proporcionan vista.",
  This_is_review_view: "Esta es la vista de revisión.",
  Type_here_to_add_description: "Escriba aquí para agregar una descripción",
  unassigned_themes: "Temas sin asignar",
  update_assessment: "Actualizar evaluación",
  Upload_an_evidence: "Subir una evidencia",
  Upload_evidence: "Subir evidencia",
  Verifiers: "Los verificadores",
  Verifiers_have_access_to_comments_that_are_made_after_they_are_assigned:
    "Los verificadores tienen acceso a los comentarios que se realizan después de su asignación. No pueden acceder a los comentarios realizados antes de la asignación.",
  approved: "Aprobado",
  verified: "Verificado",
  verify: "Verificar",
  view_assessment: "Ver evaluación",
  View_conversation: "Ver conversación",
  View_conversation_another_comments: "Ver conversación (+{{another_comments}})",
  You_can_reorder_reviewers_using_drag_and_drop: "Puede reordenar los revisores usando arrastrar y soltar",
  "You_can’t_deselect_a_site": "No puedes anular la selección de un sitio.",
  "Your_changes_are_not_auto-saved_Click_the_Publish_Changes_button_to_save_and_publish_your_changes":
    'Los cambios no se guardan automáticamente. Haga clic en el botón "Publicar cambios" para guardar y publicar los cambios.',
  "Your_standard_setup_cannot_be_updated_as_your_assessment_isn't_employing_the_latest_protocol_set":
    "No se puede actualizar su configuración estándar porque su evaluación no utiliza el protocolo más reciente. Comuníquese con el equipo de soporte de ERM para obtener ayuda.",
  theme_progress: {
    title: "Progreso del tema",
    site_assessment_label: "Evaluación del sitio",
    all_site_assessments: "Todas las evaluaciones de sitios",
    no_data: "No hay datos de tema disponibles",
    axis_labels: {
      themes: "Temas",
      task_count: "Recuento de tareas",
    },
    status: {
      unassigned: "Sin asignar",
      in_draft_unanswered: "Borrador sin responder",
      in_draft_answered: "Borrador respondido",
      declined: "Rechazado",
      in_review: "En revisión",
      reviewed: "Revisado",
    },
  },
} as const;
